export default {"gitHash":"6c65c4049e88850a5e1ff2d0380536f80a71ef13","gitHashShort":"6c65c40","time":1770068767315,"platform":"linux","arch":"x64"};